import { render, staticRenderFns } from "./BundleDiscountSection.vue?vue&type=template&id=0f49ae52&scoped=true&"
import script from "./BundleDiscountSection.vue?vue&type=script&lang=ts&"
export * from "./BundleDiscountSection.vue?vue&type=script&lang=ts&"
import style0 from "./BundleDiscountSection.vue?vue&type=style&index=0&id=0f49ae52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f49ae52",
  null
  
)

export default component.exports